import { createContext, useContext, useState, useEffect, useRef, useLayoutEffect } from "react"
import { useNavigation } from "contexts/Navigation"
import { useMotionValue } from "framer-motion"
import { mvSubscribe } from "components/model/model-variations/context"
//import { SIMILARS } from "components/grouped-variations/similar/allv2"

export const Context = createContext()

export const allFacets = {
  global_category: [],
  family: [],
  gender: [],
  size: [],
  diameter: [],
  material: [],
  alt_material: [],
  submaterial: [],
  bezel: [],
  alt_bezel: [],
  function: [],
  bracelet: [],
  dial: [],
  indexes: [],
  category: [],
  gemset: [],
  new: [],
}

const SSKEY = "rlx-gv"

export function readSS(key = null) {
  const ss = window.sessionStorage
  if (!ss) return null
  let saved = ss.getItem(SSKEY) || "{}"
  saved = JSON.parse(saved)
  //  console.log("traaack readSS", !!key ? saved?.[key] : saved)
  return !!key ? saved?.[key] : saved
}

export function writeSS(key, value) {
  const ss = window.sessionStorage
  if (!ss) return false
  const saved = readSS()
  if (!saved) return false
  saved[key] = value
  //  console.log("traaack writeSS", saved)
  ss.setItem(SSKEY, JSON.stringify(saved))
  return true
}

export const GroupedVariationsProvider = (props) => {
  const { children, thematic, flagships, usrkey } = props
  const selected = useMotionValue(null)
  const weaving = useMotionValue(props.usrkey ? readSS(props.usrkey) : null)
  const similar = useMotionValue(null)
  const enableApply = useMotionValue(false)
  const enableReset = useMotionValue(false)
  const willapply = useMotionValue(null)
  const refresh = useMotionValue(false)
  const catalog = useRef(props.catalog)
  const allFacetsCopied = JSON.parse(JSON.stringify(allFacets))
  const [userFilters, setUserFilters] = useState(allFacetsCopied)
  const [advancedPanel, setAdvancedPanel] = useState(false)
  const [filterStrip, setFilterStrip] = useState(false)
  const [filterUpdated, setFilterUpdated] = useState(null)
  /*
    function findSimilars({ uid, cardid }) {
      const item = SIMILARS.find(item => item.rmc.toLowerCase() === uid)
      if (!item) throw new Error(`rmc not found in similars: ${uid}`)
      const sim = Object.assign({}, item.model_material_similar)
      sim[cardid] = uid
      return sim
    }
  */
  function clear() {
    selected.set(null)
    willapply.set(null)
    similar.set(null)
    enableApply.set(false)
  }

  function onSelected(v) {
    //    console.log("traaack onSelected", v)
    ////    enableApply.set(v >= 0 && !sameSimilar(willapply.get()))
    refresh.set(false)
    enableApply.set(!!v)
    //    enableReset.set(v < 0 && weaving.get() !== flagships.join(","))
    //    stamp()
  }
  useEffect(() => mvSubscribe("ModelVariations selected", selected, onSelected), [])

  function getModel(uid) {
    if (!catalog.current || !uid) return null
    return Object.assign({}, catalog.current.find(v => v.uid === uid))
  }

  function weave(cardid, active) {
    let replace = null
    let _weaving = weaving.get() ?? flagships.map(v => v.rmc).join(",")
    let item = _weaving.split(",").map(getModel).find(v => v.cardid === cardid)
    replace = item?.uid ?? active
    weaving.set(_weaving.replace(replace, active))
  }

  function wapply(props) {
    /*      //    const sim = findSimilars(willapply.get())
          const sim = findSimilars(props)
          let _weaving = (weaving.get() ?? flagships.map(v => v.rmc).join(",")).split(",").map(getModel).filter(v => v.uid)
          weaving.set(_weaving.map(({ uid, cardid }) => {
            return (sim[cardid] ?? uid).toLowerCase()
          }).join(","))
          similar.set(sim)*/
  }

  return (
    <Context.Provider
      value={{
        selected,
        weave,
        weaving,
        //        weaveInit,
        enableApply,
        enableReset,
        wapply,
        willapply,
        userFilters,
        setUserFilters,
        //        updateUserFilters,
        advancedPanel,
        setAdvancedPanel,
        filterStrip,
        setFilterStrip,
        filterUpdated,
        setFilterUpdated,
        flagships,
        //        fromui,
        //        stamp,
        //        dostamp,
        refresh,
        catalog,
        similar,
        //        cardIds,
        //        colid,
        //        hash,
        clear,
        thematic,
        usrkey,
        getModel
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useWatchgrid = () => useContext(Context)
